import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Image } from "expo-image";

import { type EventOverview } from "@/schemas/events/EventOverview";
import { EventTag } from "@/schemas/events/EventTag";

type Props = {
  event: EventOverview;
};

function CoverImage({ event }: Props): React.JSX.Element {
  const isFeatured = event.tags.includes(EventTag.FEATURE);
  const isOfficial = event.tags.includes(EventTag.OFFICIAL);

  const styles = StyleSheet.create({
    container: {
      height: 250,
    },
    image: {
      width: "100%",
      height: "100%",
      borderRadius: 8,
    },
    badgeContainer: {
      position: "absolute",
      top: 12,
      left: 12,
      flexDirection: "row",
      gap: 8,
    },
    featuredBadge: {
      backgroundColor: "#9333EA",
      paddingHorizontal: 16,
      paddingVertical: 6,
      borderRadius: 20,
    },
    featuredText: {
      color: "white",
      fontSize: 14,
      fontWeight: "600",
    },
    officialBadge: {
      backgroundColor: "#22C55E",
      paddingHorizontal: 16,
      paddingVertical: 6,
      borderRadius: 20,
    },
    officialText: {
      color: "white",
      fontSize: 14,
      fontWeight: "600",
    },
  });

  return (
    <View style={styles.container}>
      <Image
        source={event.coverImageUri}
        style={styles.image}
        contentFit="cover"
        cachePolicy="memory-disk"
      />
      <View style={styles.badgeContainer}>
        {isFeatured && (
          <View style={styles.featuredBadge}>
            <Text style={styles.featuredText}>Featured</Text>
          </View>
        )}
        {isOfficial && (
          <View style={styles.officialBadge}>
            <Text style={styles.officialText}>Official</Text>
          </View>
        )}
      </View>
    </View>
  );
}

export default CoverImage;
